import React, { useState } from 'react';
import { Col, Form, Row, Input, Label, Button } from 'reactstrap';
import { msgAlert } from '../../helper';

const PaymentForm = ({callRazorpay}) => {

  const [reason, setReason] = useState('');
  const [reports, setReports] = useState([]);
  
  const onFormSubmit = (e) => {
    e.preventDefault();
    if(reason === '') 
      msgAlert('Please enter symptoms/complaints', 'This enables our team to identify the right physician for you', true, true);
    else {
      callRazorpay({
        reason,
        reports
      })
    }
  }

  const checkboxHandler = e => {
    const isChecked = e.target.checked;
    if(isChecked){
      setReports([...reports, e.target.value]);
    }else {
      let index = reports.indexOf(e.target.value);
      reports.splice(index, 1);
      setReports(reports);
    }
  }

  return(
    <Form className='payment-form' onSubmit={onFormSubmit}>
      
      
      <h2 className='consult-reason'>Send reports to the doctor</h2>
      <Row className='report'>
        <Col>
          <Label for="bloodPressure" className='report-label'>Blood pressure</Label>
          <Input type="checkbox" id="bloodPressure" value="blood_pressure" className='float-end' onChange={checkboxHandler} />
        </Col>
      </Row>
      <Row className='report'>
        <Col>
          <Label for="bloodSugar" className='report-label'>Blood sugar</Label>
          <Input type="checkbox" id="bloodSugar" value="blood_sugar" className='float-end' onChange={checkboxHandler} />
        </Col>
      </Row>
      <Row className='report'>
        <Col>
          <Label for="weight" className='report-label'>Weight</Label>
          <Input type="checkbox" id="weight" value="weight" className='float-end' onChange={checkboxHandler} />
        </Col>
      </Row>

      <h2 className='mt-3'>Specify symptoms/complaints</h2>
      <Row className='mb-5'>
        <Col className='position-relative'>
          <Input
            type="textarea"
            value={reason}
            onChange={e => setReason(e.target.value)}
            placeholder='Add your symptoms here(required)'
            maxLength="140"
            rows={4}
          />
          <span className='count'>{reason.length}/140</span>
        </Col>
      </Row>
      <Button color="primary" className='payment-btn mt-3'>Make payment</Button>
    </Form>
  );
};

export default PaymentForm;